export const environment = {
    shopId: 'ChIJe7t7dQTYvkcRbBup_mKNn5U',
    useEmulators: false,
    isAdminPage: false,
    firebaseConfig: {
        apiKey: "AIzaSyDwhZRvp1I6tocJ_xNq5lQxVtoeqjF5RNY",
        authDomain: "flora1-productsuite.firebaseapp.com",
        projectId: "flora1-productsuite",
        storageBucket: "flora1-productsuite.appspot.com",
        messagingSenderId: "215439907480",
        appId: "1:215439907480:web:6b5ebfda0167dbf7874eed",
        measurementId: "G-7WZM005FEH"
    }
};